// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumEnvironmentEventType } from './EnumEnvironmentEventType';
import {
  EnumEnvironmentEventTypeFromJSON,
  EnumEnvironmentEventTypeFromJSONTyped,
  EnumEnvironmentEventTypeToJSON,
  EnumEnvironmentEventTypeToJSONTyped,
} from './EnumEnvironmentEventType';

/**
 *
 * @export
 * @interface ResponseEnvironmentStatusEvent
 */
export interface ResponseEnvironmentStatusEvent {
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  createdAt?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentStatusEvent
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  occurredAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  resource?: string;
  /**
   *
   * @type {EnumEnvironmentEventType}
   * @memberof ResponseEnvironmentStatusEvent
   */
  type?: EnumEnvironmentEventType;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusEvent
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentStatusEvent interface.
 */
export function instanceOfResponseEnvironmentStatusEvent(
  value: object,
): value is ResponseEnvironmentStatusEvent {
  return true;
}

export function ResponseEnvironmentStatusEventFromJSON(
  json: any,
): ResponseEnvironmentStatusEvent {
  return ResponseEnvironmentStatusEventFromJSONTyped(json, false);
}

export function ResponseEnvironmentStatusEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentStatusEvent {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    id: json['id'] == null ? undefined : json['id'],
    message: json['message'] == null ? undefined : json['message'],
    name: json['name'] == null ? undefined : json['name'],
    occurredAt: json['occurred_at'] == null ? undefined : json['occurred_at'],
    resource: json['resource'] == null ? undefined : json['resource'],
    type:
      json['type'] == null
        ? undefined
        : EnumEnvironmentEventTypeFromJSON(json['type']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ResponseEnvironmentStatusEventToJSON(
  json: any,
): ResponseEnvironmentStatusEvent {
  return ResponseEnvironmentStatusEventToJSONTyped(json, false);
}

export function ResponseEnvironmentStatusEventToJSONTyped(
  value?: ResponseEnvironmentStatusEvent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    id: value['id'],
    message: value['message'],
    name: value['name'],
    occurred_at: value['occurredAt'],
    resource: value['resource'],
    type: EnumEnvironmentEventTypeToJSON(value['type']),
    updated_at: value['updatedAt'],
  };
}
